window.arrecadeNewPage = {
    scrollBtnAction: () => {

        let startHere = $("#comofunciona-split");

        $('html, body').animate({
            scrollTop: startHere && startHere.offset() ? startHere.offset().top-100 : 0 - 81
        }, 1500);
    },
};